import { render } from "./ad-json.vue?vue&type=template&id=71997ca4&scoped=true"
import script from "./ad-json.vue?vue&type=script&lang=js"
export * from "./ad-json.vue?vue&type=script&lang=js"

import "./ad-json.vue?vue&type=style&index=0&id=71997ca4&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71997ca4"]])

export default __exports__